'use strict';

import angular from 'angular';
import Main from './main.controller';

export default angular.module('aperamApp.borne.main', [])
  .controller('MainController', Main)
  .name;


// WEBPACK FOOTER //
// ./client/app/borne/main/index.js